<template class="telaToda">
  <div class="telaEndereco">
    <v-form ref="formDadosOperacionais" @submit.prevent v-model="validDadosOperacionais">
      <v-container class="pt-0"> 
      <div class="header-step">
        <h3>Dados Operacionais</h3>
        <p>Vamos conhecer um pouco da operação.</p>
      </div>
      <div v-if="mediaEditadoFormated != null">
        <v-layout row wrap>
          <v-flex
            xs12
            md6
          >
            <v-text-field
              :disabled="disabledDadosOperacionais"
              v-model="modelValorTransportadoMes"
              label="Valor total transportado no mês"
             
              required
             
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-text-field
              :disabled="disabledDadosOperacionais"
              v-model="dadosOperacionais.quantidadeViagensMes"
              label="Quantidade média de viagens no mês"
              :rules="regras.notNull"
              type="number"
              min="0"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-text-field
              :disabled="disabledDadosOperacionais"
              v-model="modelValorMaximoTransportadoViagem"
              label="Valor máximo transportado por viagem"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex
          xs12
          md6
          v-show="mostrarMedia"
        >
          <p class="title-media">Valor médio transportado por viagem: </p>
          <p class="resultado-media">
            {{ mediaEditadoFormated }}
          </p>
        </v-flex>
          
          
        </v-layout>
      </div>
      <div v-else>
        <v-layout row wrap>
          <v-flex
            xs12
            md6
          >
          <v-text-field
            :disabled="disabledDadosOperacionais"
              v-model="modelValorTransportadoMes"
              label="Valor total transportado no mês"
              :rules="functionsComputed.regras.valorPremio(modelValorTransportadoMes)"
              required
              v-money="maskComputed.maskMoney"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-text-field
              :disabled="disabledDadosOperacionais"
              v-model="dadosOperacionais.quantidadeViagensMes"
              label="Quantidade média de viagens no mês"
              :rules="regras.notNull"
              type="number"
              min="0"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex
            xs12
            md6
          >
            <v-text-field
              :disabled="disabledDadosOperacionais"
              v-model="modelValorMaximoTransportadoViagem"
              label="Valor máximo transportado por viagem"
              :rules= "functionsComputed.regras.valorPremio(modelValorMaximoTransportadoViagem)"
              v-money="maskComputed.maskMoney"
              required
            >
            </v-text-field>
          </v-flex>
          <v-flex
            xs12
            md6
            v-show="mostrarMedia"
          >
            <p class="title-media">Valor médio transportado por viagem: </p>
            <p class="resultado-media">
              {{ mediaFiltrada }}
            </p>
          </v-flex>
        </v-layout>
      </div>
    <v-layout class="mt-4" row>
        <v-flex
          xs12
          md12
        >
          <h4 class="sub-title-values">Informe o percentual transportado no mês por tipo de frota:</h4>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            :disabled="disabledDadosOperacionais"
            v-model="dadosOperacionais.percentualMesFrota.propria"
            class="mt-0"
            label="Própria"
            type="number"
            min="0"
            max="100"
            suffix="%"      
            :rules= "functionsComputed.regras.valorPorcentagem(dadosOperacionais.percentualMesFrota.propria)"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            :disabled="disabledDadosOperacionais"
            v-model="dadosOperacionais.percentualMesFrota.agregados"
            class="mt-0"
            suffix="%"
            type="number"
            min="0"
            max="100"
            label="Agregados"
            :rules= "functionsComputed.regras.valorPorcentagem(dadosOperacionais.percentualMesFrota.agregados)"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            :disabled="disabledDadosOperacionais"
            v-model="dadosOperacionais.percentualMesFrota.terceiros"
            class="mt-0"
            label="Terceiros"
            type="number"
            min="0"
            max="100"
            suffix="%"
            :rules= "functionsComputed.regras.valorPorcentagem(dadosOperacionais.percentualMesFrota.agregados)"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex
          xs4
          md3
        >
          <v-btn
            flat
            @click="$emit('voltarDadosOperacionais', true)"
            color="primary"
          >
            Voltar
          </v-btn>
        </v-flex>
        <v-flex
          xs4
          md3
        >
          <v-btn
            :disabled="!checarValores()"
            type="submit"
            @click="sendDataToParent"
            color="primary"
          >
            proximo
          </v-btn>
        </v-flex>
        <v-flex
          xs4
          md3
        >
         <v-btn flat color="primary" :disabled="disabledDadosOperacionais">
            salvar oportunidade
          </v-btn>
        </v-flex>
      </v-layout>
  </v-container>
</v-form>
</div>
</template>

<script>
import mask from "@/helpers/mask";
import {VMoney} from 'v-money';
import functions from "@/components/pages/listagem-solicitacoes/functions.js";
import CustomFormat from '@/helpers/custom-format';

export default {
  name:"QARDadosOperacionais",
  directives: {
    money: VMoney
  },
  props: {
    protocolo: String,
    dadosQuestionarioCompleto: {
      type: Object, 
      require: false
    }
  },
  data () {
    return {
      mediaFiltrada: null,
      validDadosOperacionais: false,
      mediaEditadoFormated: null, 
      mostrarMedia: false,
      modelValorTransportadoMes: null,
      modelValorMaximoTransportadoViagem: null,
      
      dadosOperacionais: {
        valorTransportadoMes: null,
        quantidadeViagensMes: null,
        valorMaximoTransportadoViagem: null,
        percentualMesFrota: {
          propria: null,
          agregados: null,
          terceiros: null,
        },
      },
      valorCorreto: false,
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      },

    }},
    computed: {
      disabledDadosOperacionais() {
        return this.protocolo != null || this.dadosQuestionarioCompleto.id != null;
      },
      formRulesComputed: function() {
        return formRules;
      },
      maskComputed: function() {
        return mask; 
      },
      functionsComputed: function() {
        return functions;
      },
    },
    watch: {
      dadosQuestionarioCompleto(val) {
        if(val.id != null && val.id !=undefined) {
          this.modelValorTransportadoMes = this.formatMoney(val.dadosOperacionais.valorTransportadoMes);
          this.dadosOperacionais.quantidadeViagensMes = val.dadosOperacionais.quantidadeViagensMes;
          this.modelValorMaximoTransportadoViagem = this.formatMoney(val.dadosOperacionais.maiorValorEmbarcado);
          this.dadosOperacionais.percentualMesFrota.propria = val.dadosOperacionais.percentualVeiculoProprio;
          this.dadosOperacionais.percentualMesFrota.agregados = val.dadosOperacionais.percentualVeiculoAgregado;
          this.dadosOperacionais.percentualMesFrota.terceiros = val.dadosOperacionais.percentualVeiculoAutonomo;
          this.calcularMediaValoresEditado(val.dadosOperacionais.valorTransportadoMes, val.dadosOperacionais.quantidadeViagensMes);
        }

      },
      'dadosOperacionais.percentualMesFrota.propria': {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      },
      'dadosOperacionais.percentualMesFrota.agregados': {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      },
      'dadosOperacionais.percentualMesFrota.terceiros': {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      },
      'modelValorTransportadoMes': {
       
        handler: function () {

          if(!this.dadosQuestionarioCompleto.id){

            this.calcularMediaValores();
          }
        },
        deep: true
      },
      'dadosOperacionais.quantidadeViagensMes': {
        handler: function () {
          if(!this.dadosQuestionarioCompleto.id){
            this.calcularMediaValores();
          }
        },
        deep: true
      },
      'modelValorMaximoTransportadoViagem': {
        handler: function () {
          if(!this.dadosQuestionarioCompleto.id){
            this.calcularMediaValores();
          }
        },
        deep: true
      },
      'dadosOperacionais.percentualMesFrota.propria': {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      },
      'dadosOperacionais.percentualMesFrota.agregados': {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      },
      'dadosOperacionais.percentualMesFrota.terceiros' : {
        handler: function () {
          this.checarValorFrotas();
        },
        deep: true
      }
    },
    mounted() {
      this.$refs.formDadosOperacionais.resetValidation();
    },
    methods: {
      checarValores() {
        if(this.valorCorreto == true && this.validDadosOperacionais == true){
          return true
        }
        return false
      },
      checarValorFrotas() {
        var proprio = parseInt(this.dadosOperacionais.percentualMesFrota.propria);
        var agregados = parseInt(this.dadosOperacionais.percentualMesFrota.agregados);
        var terceiros = parseInt(this.dadosOperacionais.percentualMesFrota.terceiros);
        if(isNaN(proprio)) proprio = 0
        if(isNaN(agregados)) agregados = 0
        if(isNaN(terceiros)) terceiros = 0
        
        var valor = proprio + agregados + terceiros;
        if(valor == 100) {
          return this.valorCorreto = true;
        }
        return this.valorCorreto = false;
      },
      formatMoney(amount) {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL"
        }).format(amount || 0);
      },

      sendDataToParent() {
        this.dadosOperacionais.valorTransportadoMes = CustomFormat.removeMoneyFormat(this.modelValorTransportadoMes);
        this.dadosOperacionais.valorMaximoTransportadoViagem = CustomFormat.removeMoneyFormat(this.modelValorMaximoTransportadoViagem);
        this.$emit('dadosOperacionais', this.dadosOperacionais);
      },

      calcularMediaValores() {
       
        var valorTransportadoMes = this.modelValorTransportadoMes ? this.modelValorTransportadoMes.replace('R$ ','.').replaceAll('.','').replaceAll(',','.') : this.modelValorTransportadoMes
        var quantidadeViagensMes = parseInt(this.dadosOperacionais.quantidadeViagensMes);
        var media = valorTransportadoMes / quantidadeViagensMes;
        var arredondado = media.toFixed(2);
        if(!isNaN(arredondado) || quantidadeViagensMes.length && valorTransportadoMes.length) {
          this.mostrarMedia = true;
          this.mediaFiltrada = this.formatMoney(arredondado);
        }
      },
      calcularMediaValoresEditado(valorTransportadoMes,quantidadeViagensMes ) {
        var valorTransportadoMes = valorTransportadoMes
        var quantidadeViagensMes = parseInt(quantidadeViagensMes);
        var media = valorTransportadoMes / quantidadeViagensMes;
        var arredondado = media.toFixed(2);
        if(!isNaN(arredondado) || quantidadeViagensMes.length && valorTransportadoMes.length) {
          this.mostrarMedia = true;
          this.mediaEditadoFormated = this.formatMoney(arredondado)
        }
      }
    }

}
</script>

<style>
.QuestionarioAnaliseRiscos .sub-title-values {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
}
.QuestionarioAnaliseRiscos .title-media {
  font-weight: 400;
  color: #7f7f7f;
  font-size: 16px;
  text-align: center;
  margin-bottom: 0;
}
.QuestionarioAnaliseRiscos .resultado-media {
  font-weight: bold;
  color: #7f7f7f;
  font-size: 18px;
  text-align: center;
}
.QuestionarioAnaliseRiscos .telaEndereco{
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARDadosOperacionais.vue